import clsx from 'clsx';
import { FC } from 'react';

import { FilterItemProps, FilterOption, PlpFiltersConditionalProps } from '@/plp/components/PlpFilters/PlpFilters.type';

import { FilterOptionField } from './FilterOptionField';
import styles from './FilterOptionFieldsGroup.module.scss';

type Props = {
  currentFilters: FilterOption[];
  options: FilterItemProps[];
} & PlpFiltersConditionalProps;

export const FilterOptionFieldsGroup: FC<Props> = ({ currentFilters, options, ...props }) => {
  return (
    <div className={clsx(styles.rootOptionsGroup, 'wrapper', 'wrapper--checkbox')}>
      {options.map((option) => (
        <FilterOptionField
          {...option}
          checked={currentFilters.some((filter) => filter.value === option.value && filter.filter === option.filter)}
          key={option.value}
          {...props}
        />
      ))}
    </div>
  );
};
